import SupprtDetails from '../../../components/Details';
function Details( props ) {
    const updatedProps = {
        ...props,
        context: 'vendor',
    };
    return <SupprtDetails { ...updatedProps } />;
}

export default Details;
